import React from "react";
import LegalPage from "./LegalPage";

const Terms = () => <LegalPage tKey="pages.terms" testId="terms-page" />;
export default Terms;
